/**
 * Custom Hook: usePasien
 * Manages patient data fetching and state
 */

import { useState, useEffect, useCallback } from "react";
import { API_ENDPOINTS } from "../constants/apiEndpoints";
import { mapApiPatient } from "../utils/dataTransformers";

export const usePasien = () => {
  const [patientOptions, setPatientOptions] = useState([]);
  const [selectedPatientId, setSelectedPatientId] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchAllPatients = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const res = await fetch(API_ENDPOINTS.PASIEN_REGISTRASI_HARI_INI, {
        headers: { Accept: "application/json" },
      });

      if (!res.ok) throw new Error("Gagal ambil data pasien");

      const json = await res.json();
      const arr = Array.isArray(json?.data) ? json.data : [];
      setPatientOptions(arr.map(mapApiPatient));
    } catch (err) {
      console.error("Gagal ambil data pasien:", err);
      setError(err.message);
      setPatientOptions([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchAllPatients();
  }, [fetchAllPatients]);

  const selectedPatient = patientOptions.find(
    (p) => p.id === selectedPatientId
  );

  return {
    patientOptions,
    selectedPatientId,
    setSelectedPatientId,
    selectedPatient,
    loading,
    error,
    refetch: fetchAllPatients,
  };
};

export default usePasien;
